import * as Yup from 'yup';
import plantillasFormModel from './plantillasFormModel';

const {
  formField: { name, message, category, business },
} = plantillasFormModel;

export default Yup.object().shape({
  [name.name]: Yup.string().required(`${name.label} es obligatorio`),
  [message.name]: Yup.string().required(`${message.label} es obligatorio`),
  [category.name]: Yup.object()
    .shape({
      value: Yup.string().required(),
      label: Yup.string().required(),
    })
    .default(undefined) // 👈
    .required(`${category.label} es obligatorio`),
  [business.name]: Yup.object()
    .shape({
      value: Yup.string().required(),
      label: Yup.string().required(),
    })
    .default(undefined) // 👈
    .required(`${business.label} es obligatorio`),
});
